
import { getReservationClient } from '@/api/reservationClient';
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({})
export default class extends Vue {
  @Prop({ required: true }) private uid!: string;

  mounted() {
    this.getReservationClient();
  }

  private loading = true;

  private reservationDetail: any = {
    uid: '',
    reservationCode: '',
    facilityName: '',
    name: '',
    phone: '',
    gender: 0,
    postCode: '',
    address: '',
    addressDetail: '',
    email: '',
    fewDay: 1,
    price: 0,
    settingUnitStatus: 1,
    hourUnitStatus: false,
    hours: [],
    startTime: '',
    endTime: '',
    item: {
      uid: '',
      name: '',
      category: {
        uid: '',
        name: '',
      },
      institution: {
        uid: '',
      },
    },
    discountPolicy: {
      uid: '',
      title: '',
    },
    people: 1,
    totalPeople: 0,
    groupReservationStatus: true,
    groupReservation: [],
    additionals: [],
    paymentMethod: '',
    status: 0,
    approvalStatus: false,
    paymentStatus: true,
    itemName: '',
  };

  private getReservationClient() {
    this.loading = true;
    getReservationClient(this.uid).then((res) => {
      this.loading = false;
      this.reservationDetail = res.data;
    });
  }
}
